module.exports = __webpack_public_path__ + "static/media/filter_1_white_18dp.6398dce5.svg";